/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSatellite2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M14.856 13.387l2.121 2.121M16.447 16.039l1.061-1.061a1.5 1.5 0 0 1 2.121 0l3.182 3.182a1.5 1.5 0 0 1 0 2.121l-1.061 1.061a1.5 1.5 0 0 1-2.121 0l-3.182-3.182a1.5 1.5 0 0 1 0-2.121zM10.613 9.144L8.492 7.023M2.657 2.25l1.061-1.061a1.5 1.5 0 0 1 2.121 0l3.182 3.182a1.5 1.5 0 0 1 0 2.121l-1.06 1.061a1.5 1.5 0 0 1-2.121 0L2.657 4.371a1.501 1.501 0 0 1 0-2.121zM12.75 8.25a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM2.947 10.447c-2.96 2.898-3.011 7.646-.113 10.606a7.5 7.5 0 0 0 10.719 0M5.6 13.1a3.75 3.75 0 0 0 5.3 5.3" />
      </g>
    </svg>
  ),
);
